import { OWN_ORIGIN } from "@/base/base.constants";

const GetAssignmentUrl = (id, asPath) => {
  const returnUrl = OWN_ORIGIN + asPath;

  return `/assignments/create?contentIds=${id}&createdFrom=${id}&return_url=${returnUrl}`;
};

export default GetAssignmentUrl;
